import {Action} from '@ngrx/store';

export const CONVERT_TO_PDF_ACTION = 'CONVERT_TO_PDF_ACTION';

export class ConvertToPdfAction implements Action {
  readonly type = CONVERT_TO_PDF_ACTION;

  constructor(public payload: any) {
  }
}
